<template>
  <div class="ts-p-3">
    <h6
      class="ts-text-white ts-uppercase ts-bg-blue-500 ts-px-2 ts-py-1 ts-rounded-md"
      style="width:fit-content"
    >{{ $t('promotion.condition') }}</h6>
    <table class="ts-w-full table">
      <thead>
        <tr>
          <th class="ts-w-32">{{ $t('promotion.description') }}</th>
          <th class="ts-w-64">{{ $t('promotion.sign') }}</th>
          <th class="ts-w-40">{{ $t('promotion.amountFrom') }}</th>
          <th class="ts-w-40">{{ $t('promotion.amountTo') }}</th>
          <th>{{ $t('promotion.freeItem') }}</th>
          <th class="ts-w-40">{{ $t('promotion.status') }}</th>
          <th class="ts-w-1">
            <a href="#" @click.prevent="addItem">
              <i class="fa fa-plus"></i>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(con, index) in model.condition" :key="index">
          <td valign="middle">Sale Volume</td>
          <td>
            <select 
              v-model="con.operator_sign" 
              class="form-control"
              @change="operatorChange(con)"
            >
              <option value="=">Equal</option>
              <option value="between">Between</option>
              <option value=">=">Greater or equal</option>
            </select>
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.operator_sign')">
              {{ errors.first('condition.' + index + '.operator_sign') }}
            </div>
          </td>
          <td>
            <input 
              v-model.number="con.amount_from" 
              type="number" 
              step="any" class="form-control" 
            />
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.amount_from')">
              {{ errors.first('condition.' + index + '.amount_from') }}
            </div>
          </td>
          <td>
            <input
              v-model.number="con.amount_to"
              type="number"
              step="any"
              :disabled="con.operator_sign != 'between'"
              class="form-control"
            />
            <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.amount_to')">
              {{ errors.first('condition.' + index + '.amount_to') }}
            </div>            
          </td>
          <td>
            <div
              class="ts-flex ts-items-center ts-space-x-3 ts-space-y-1"
              v-for="(item, subIndex) in con.items"
              :key="subIndex"
            >
              <div class="ts-w-1/3">
                <input type="text" :value="getProductName(item.pro_sale_code_id)" class="form-control" readonly>
                <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.items.' + subIndex + '.pro_sale_code_id')">
                  {{ errors.first('condition.' + index + '.items.' + subIndex + '.pro_sale_code_id') }}
                </div>  
              </div>
              <div>
                <input v-model.number="item.quantity" type="number" class="form-control" />
                <div class="validate ts-text-xs" v-if="errors.has('condition.' + index + '.items.' + subIndex + '.quantity')">
                  {{ errors.first('condition.' + index + '.items.' + subIndex + '.quantity') }}
                </div>  
              </div>
              <div valign="middle" class="ts-text-xs">
                <ts-checkbox v-model="item.is_allow_adjust_free_quantity">{{
                  $t('promotion.allowAdjustFreeQuantiry')
                }}</ts-checkbox>
              </div>
              <div class="ts-space-x-3">
                <a href="#"
                  v-if="subIndex"
                  @click.prevent="removeSubItem(index, subIndex)"
                  class="ts-text-red-700"
                >
                  <i class="fa fa-trash"></i>
                </a>
                <a href="#"
                  v-if="subIndex == 0"
                  @click.prevent="addSubItem(con)"
                >
                  <i class="fa fa-plus"></i>
                </a>
              </div>
            </div>
          </td>
          <td>
            <a-select
              v-model="con.free_status" 
              class="ts-w-full"
            >
              <a-select-option value="All">All</a-select-option>
              <a-select-option value="Any">Any</a-select-option>
            </a-select>
          </td>
          <td>
            <a
              href="#"
              class="ts-text-red-700 hover:ts-text-red-700"
              @click.prevent="removeItem(index)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- show product list pop-up -->
    <a-modal
      v-if="show_form"
      v-model="show_form"
      :title="$t('promotion.product')"
      :footer="null"
    >
      <ProductList v-model="items" />
    </a-modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './modal-popup/free-item-peramount-product-list.vue'
export default {
  name: 'condition',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      model: {},
      errors: new Errors(),
      show_form: false,
      items: [],
      subRow: {       
        pro_sale_code_id: null,
        quantity: 1
      },
      row: {
        promo_free_item_cond_id: null,
        operator_sign: '=',
        amount_from: 100,
        amount_to: null,
        free_status: 'All',
        items: [
          {
            pro_sale_code_id: null,
            quantity: 1
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('promotion/resource', ['getProductName'])
  },
  created() {
    this.model = this.value
  },
  methods: {
    addItem() {
      this.model.condition.push(_.cloneDeep(this.row))
    },
    removeItem(index) {
      this.model.condition.splice(index, 1)
    },
    addSubItem(con){
      this.show_form = true
      this.items = con.items
    },
    removeSubItem(mainIndex, subIndex){
      this.model.condition[mainIndex].items.splice(subIndex, 1)
    },
    operatorChange(row){
      if(row.operator_sign != 'between'){
        row.amount_to = null
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
